export default "__VITE_PUBLIC_ASSET__9533db37__"